import * as React from "react";
import type { Opportunity } from "@/data/types";
import { Reveal } from "@/components/presentation/primitives";

interface Props {
  opportunity: Opportunity;
}

export const OpportunitySection: React.FC<Props> = ({ opportunity }) => {
  if (!opportunity) return null;
  return (
    <section
      className="relative w-full overflow-hidden bg-charcoal py-24 md:py-36"
      data-testid="opportunity-section"
      aria-label="How I would position it"
    >
      <div className="absolute inset-0 grain-overlay opacity-[0.08]" />
      <div className="relative mx-auto w-full max-w-4xl px-6 md:px-10">
        <Reveal>
          <p className="text-[0.7rem] uppercase tracking-[0.28em] text-brass">
            How I would position it
          </p>
        </Reveal>
        {opportunity.headline && (
          <Reveal>
            <h2 className="mt-5 max-w-2xl font-serif text-3xl leading-tight text-ivory md:text-5xl">
              {opportunity.headline}
            </h2>
          </Reveal>
        )}

        {opportunity.body && (
          <Reveal delay={0.15}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-ivory/75 md:text-lg">
              {opportunity.body}
            </p>
          </Reveal>
        )}

        {opportunity.pullQuote && (
          <Reveal delay={0.3}>
            <blockquote className="mt-16 border-t border-ivory/15 pt-12">
              <span className="mb-6 block h-px w-12 bg-brass" />
              <p className="max-w-3xl font-serif text-3xl leading-[1.15] text-ivory md:text-5xl">
                {opportunity.pullQuote}
              </p>
            </blockquote>
          </Reveal>
        )}
      </div>
    </section>
  );
};
